<div class="remove-address-dialog" [mmTestId]="'ADDRESS_BOOK_PAGE.REMOVE_CONFIRMATION_DIALOG'">
    <mm-dialog-title>
        {{ 'PAGES.ACCOUNT.ADDRESS_BOOK.ADDRESS_REMOVE_CONFIRMATION_TITLE' | translate }}
    </mm-dialog-title>

    <mm-dialog-content>
        <div class="remove-address-dialog__content">
            <app-address-details [address]="address"></app-address-details>
        </div>
    </mm-dialog-content>

    <mm-dialog-footer>
        <button
            mm-button
            mmDialogClose
            color="ghost"
            class="remove-address-dialog__cancel-button"
            [mmTestTarget]="'cancel-button'">
            {{ 'REGULAR.CANCEL' | translate}}
        </button>
        <button
            mm-button
            mmDialogClose="true"
            color="warning"
            class="remove-address-dialog__remove-button"
            [mmTestTarget]="'remove-button'">
            {{ 'PAGES.ACCOUNT.ADDRESS_BOOK.REMOVE_ADDRESS' | translate }}
        </button>
    </mm-dialog-footer>
</div>
